export default __webpack_public_path__ + "static/media/Payment_Module_Video.58f7304f.mp4";